export default {

    speed: 400,
    activeLoad: 1,
    toggle: 'false',
    icon: 'plus',
    titleBackground: '#ffffff',
    titleBackgroundHover: '#f1f1f1',
    titleColor: '#555',
    titleColorHover: '#333',
    contentBackground: '#fff',
    contentBorderColor: '#bbb',
    titleBorderColor: '#bbb',
    titleTag: 'h6',
    fontSize: 14,
    iconSize: 10,
    iconColor: '#888',
    iconColorHover: '#555',

    useCustomFont: false,
    customFontName: "'Helvetica Neue', sans-serif",
    customFontWeight: "400",
    customFontStyle: 'normal',

    fontFamily: 'Roboto',
    fontWeight: '400',
    fontStyle: 'normal',
    fontGoogleLoad: 'Roboto:400',

    letterSpacing: 0,

    accordionTitles: [
        {
            titleId: 'bundle-accordion-title-'+Math.random().toString(36).substr(2, 16),
            titleText: 'Click to add your title'
        },
        {
            titleId: 'bundle-accordion-title-'+Math.random().toString(36).substr(2, 16),
            titleText: 'Click to add your title'
        },
        {
            titleId: 'bundle-accordion-title-'+Math.random().toString(36).substr(2, 16),
            titleText: 'Click to add your title'
        }
    ]

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/accordionsettings.js